import { CommentActionTypes } from './constants';

export const getCommentResponseSuccess = ( actionType = '', data = {} ) => ({
  type: CommentActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const getCommentResponseError = ( actionType = '', error = '' ) => ({
  type: CommentActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error  },
});

export const getComment = ( params ) => {
  return {
    type: CommentActionTypes.GET_COMMENT,
    payload: params,
  }
};

export const getCommentById = ( params ) => {
  return {
    type: CommentActionTypes.GET_COMMENT_BY_ID,
    payload: params,
  }
};

export const addComment = ( params ) => ({
  type: CommentActionTypes.ADD_COMMENT,
  payload: params,
});

export const updateComment = ( params ) => ({
  type: CommentActionTypes.UPDATE_COMMENT,
  payload: params,
});

export const deleteComment = ( id ) => ({
  type: CommentActionTypes.DELETE_COMMENT,
  payload: id,
});

export const resetComment = () => ({
  type: CommentActionTypes.RESET_COMMENT,
  payload: {},
});
